import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large to="/">{t("Comments, questions, recipes")}</Large>
              <a href="mailto:me@vandyio.com">
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={14} md={12} sm={12} xs={12}>
              <Title>{t("Guiding Lights")}</Title>
                <Large as="span">{t("API First Strategy")}</Large>
                <Large as="span">{t("Testing & Security Principles")}</Large>
                <Large as="span">{t("Turn-key with Support")}</Large>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <br />
              <Language>{t("Address")}</Language>
              <Para>17875 Von Karman Ave</Para>
              <Para>Suite 150-250</Para>
              <Para>Irvine CA 92614, United States</Para>
              <Para>support@usclarity.com</Para>
            </Col>
            
            <Col lg={8} md={8} sm={12} xs={12}>
              <br />
              <Title>{t("Features")}</Title>
                <a href="/docs" style={{ textDecoration: "none" }}>
                <Large as="span">{t("Docs")}</Large>
                </a>
                <a href="/api/v1/statementify/docs/" style={{ textDecoration: "none" }}>
                <Large as="span">{t("Swagger UI")}</Large>
                </a>
                <a href="/api/v1/statementify/docs/#/System/healthCheck" style={{ textDecoration: "none" }}>
                <Large as="span">{t("Health Check")}</Large>
                </a>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <br />
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon
                    src="spain.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
            <br/>
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="70px"
                />
              </LogoContainer>
            </NavLink>
              Credits:
              &nbsp;&nbsp;
              <SocialLink
              href="https://github.com/vandy-io"
              src="github.svg"
              />
              &nbsp;&nbsp;
              <SocialLink
              href="https://www.linkedin.com/in/vandy-io/"
              src="linkedin.svg"
              />
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
